import type { NavigationMenuItem } from '@nuxt/ui'
import type { ActionMenuItem } from './grid'
import { Icones } from './icons'
import { navigateTo } from '#imports'
// import { useMessage } from '~/composables/useMessage'
// import { useSetup } from '~/composables/gerencial/useSetup'

// function updateTables(): void {
//   useModal().confirm({
//     title: 'Atualizar Tabelas',
//     description: 'Deseja realmente atualizar as tabelas ?',
//     okClick: async () => {
//       const response = await useSetup().exec('update')
//       if (response)
//         useMessage().showMessage('Tabelas atualizadas com sucesso !')
//       else
//         useMessage().showMessage('Erro ao atualizar as tabelas !')
//     }
//   })
// }

export enum ModuleType {
  DICOMVIX = 'dicomvix',
  CLINUX = 'clinux',
  OTRS = 'otrs',
  PORTAL = 'portal',
  QUESTIONARIO = 'questionario',
  DOCTOR = 'medico',
  CLIENT = 'client',
  RESULTADO = 'resultado'
}
export const portalMenu: NavigationMenuItem[] = [
  {
    label: 'Agendamento',
    to: '/portal/agendamento',
    icon: Icones.agendamento_confirmar
  },
  {
    label: 'Resultados',
    to: '/paciente'
  }
]
export const doctorMenu: NavigationMenuItem[] = [
  {
    label: 'Resultados',
    to: '/solicitante'
  }
]
export const gestaoMenu: NavigationMenuItem[] = [
  {
    label: 'Laudo',
    to: '/laudo/gestao'
  }
]
export const otrsMenu: NavigationMenuItem[] = [
  {
    label: 'Gerencial',
    children: [
      { label: 'Empresa', to: '/gerencial/empresa', icon: Icones.empresa },
      { label: 'Funcionário', to: '/gerencial/funcionario', icon: Icones.funcionario },
      { label: 'Usuário', to: '/gerencial/usuario', icon: Icones.usuario },
      { label: 'Editor', to: '/gerencial/layout', icon: Icones.layout },
      { label: 'Sistema', to: '/gerencial/formulario', icon: Icones.sistema },
      { label: 'Auto-Texto', to: '/laudo/texto', icon: Icones.texto },
      { label: 'Setup', to: '/setup', icon: Icones.sistema }
    ]
  },
  {
    label: 'Atendimento',
    children: [
      { label: 'Chamado', to: '/otrs/chamado', icon: Icones.paciente },
      { label: 'Cliente', to: '/otrs/empresa', icon: Icones.empresa },
      { label: 'Versão', to: '/otrs/versao', icon: Icones.sistema }
    ]
  }
]
export const clientMenu: NavigationMenuItem[] = [
  {
    label: 'Atendimento',
    to: '/atendimento/clinica',
    icon: Icones.clinica
  },
  {
    label: 'Resultado',
    to: '/atendimento/resultado',
    icon: Icones.resultado
  },
  {
    label: 'Paciente',
    to: '/atendimento/paciente',
    icon: Icones.paciente
  },
  {
    label: 'Solicitante',
    to: '/atendimento/medico',
    icon: Icones.medico
  }
]
export const reportMenu = (reportLinks: NavigationMenuItem[]): NavigationMenuItem => ({
  label: 'Relatórios',
  icon: Icones.report,
  children: reportLinks
})

export const mainMenu: NavigationMenuItem[] = [
  {
    label: 'Gerencial',
    icon: Icones.empresa,
    children: [
      { label: 'Empresa', to: '/gerencial/empresa', icon: Icones.empresa },
      { label: 'Funcionário', to: '/gerencial/funcionario', icon: Icones.funcionario },
      { label: 'Usuário', to: '/gerencial/usuario', icon: Icones.usuario },
      { label: 'Sala', to: '/gerencial/sala', icon: Icones.sala },
      { label: 'Médico', to: '/gerencial/medico', icon: Icones.medico },
      { label: 'Modalidade', to: '/gerencial/modalidade', icon: Icones.modalidade },
      { label: 'Procedimento', to: '/gerencial/procedimento', icon: Icones.procedimento },
      { label: 'Metas', to: '/gerencial/metas', icon: Icones.meta },
      { label: 'Editor', to: '/gerencial/layout', icon: Icones.layout },
      { label: 'Questionário', to: '/gerencial/questionario', icon: Icones.questionario }
    ]
  },
  {
    label: 'Atendimento',
    icon: Icones.clinica,
    children: [
      { label: 'Atendimento', to: '/atendimento/clinica', icon: Icones.clinica },
      { label: 'Resultado', to: '/atendimento/resultado', icon: Icones.resultado },
      { label: 'Paciente', to: '/atendimento/paciente', icon: Icones.paciente },
      { label: 'Solicitante', to: '/atendimento/medico', icon: Icones.medico }
      // { label: 'Agendamento', to: '/portal/agendamento', icon: Icones.agendamento_confirmar }
    ]
  },
  {
    label: 'Laudo',
    icon: Icones.gestao,
    children: [
      { label: 'Gestão', to: '/laudo/gestao', icon: Icones.gestao },
      // { label: 'Prescrição', to: '/laudo/prescricao', icon: Icones.prescricao },
      { label: 'Fila', to: '/laudo/fila', icon: Icones.fila },
      { label: 'Modelo', to: '/gerencial/modelo', icon: Icones.laudo },
      { label: 'Auto-Texto', to: '/laudo/texto', icon: Icones.texto }
    ]
  },
  {
    label: 'Estoque',
    icon: Icones.kit,
    children: [
      { label: 'Material', to: '/estoque/material', icon: Icones.material },
      { label: 'Unidade', to: '/estoque/unidade', icon: Icones.unidade },
      { label: 'Kit', to: '/estoque/kit', icon: Icones.kit }
    ]
  },
  {
    label: 'Faturamento',
    icon: Icones.convenio,
    children: [
      { label: 'Convênio', to: '/faturamento/convenio', icon: Icones.convenio },
      { label: 'Plano', to: '/faturamento/plano', icon: Icones.plano }
    ]
  },
  // {
  //   label: 'Financeiro',
  //   icon: Icones.financeiro_banco,
  //   children: [
  //     { label: 'Fornecedores', to: '/financeiro/fornecedor', icon: Icones.financeiro_fornecedor },
  //     { label: 'Bancos', to: '/financeiro/banco', icon: Icones.financeiro_banco },
  //     { label: 'Planos de Conta', to: '/financeiro/conta', icon: Icones.financeiro_conta },
  //     { label: 'Centro de Custo', to: '/financeiro/centro', icon: Icones.financeiro_centro },
  //     { label: 'Serviços', to: '/financeiro/servico', icon: Icones.financeiro_servico }
  //   ]
  // },
  {
    label: 'Sistema',
    icon: Icones.setup,
    children: [
      { label: 'Setup', to: '/setup', icon: Icones.setup },
      { label: 'Permissão', to: '/gerencial/permissao', icon: Icones.acesso },
      { label: 'Módulos', to: '/gerencial/formulario', icon: Icones.modulo },
      { label: 'Cadastro', to: '/setup/aviso', icon: Icones.report },
      { label: 'ChangeLog', to: '/changelog', icon: Icones.changelog },
      { label: 'Manual do Usuário', to: '/user', icon: Icones.manual }
    ]
  }
]
export const cadastroMenu: ActionMenuItem[] = [
  { title: 'Aviso', icon: Icones.aviso, action: () => navigateTo('/setup/aviso') },
  { title: 'Urgente', icon: Icones.urgente, action: () => navigateTo('/setup/urgente') },
  { title: 'Cancelamento', icon: Icones.cancelamento, action: () => navigateTo('/setup/cancelamento') },
  { title: 'Documento', icon: Icones.anexo, action: () => navigateTo('/setup/anexo') },
  { title: '-' },
  { title: 'Sla', icon: Icones.sla, action: () => navigateTo('/setup/sla') },
  { title: 'Procedência', icon: Icones.procedencia, action: () => navigateTo('/setup/procedencia') },
  { title: 'Achado Crítico', icon: Icones.achado, action: () => navigateTo('/setup/achado') },
  { title: '-' },
  { title: 'Pendência', icon: Icones.pendencia, action: () => navigateTo('/setup/complemento') },
  { title: 'Reconvocação', icon: Icones.reconvocacao, action: () => navigateTo('/setup/reconvocacao') },
  { title: 'Solução', icon: Icones.solucao, action: () => navigateTo('/setup/solucao') },
  { title: '-' },
  { title: 'Laudo Favorito', icon: Icones.favorito, action: () => navigateTo('/setup/favorito') },
  { title: 'Laudo Revisão', icon: Icones.revisao, action: () => navigateTo('/setup/revisao') },
  { title: 'Laudo Auditoria', icon: Icones.auditoria, action: () => navigateTo('/setup/auditoria') },
  { title: 'Laudo Assinatura', icon: Icones.laudo_pdf, action: () => navigateTo('/setup/tipo') },
  { title: 'Laudo Exclusão', icon: Icones.laudo_del, action: () => navigateTo('/setup/exclusao') },
  { title: '-' },
  { title: 'Grupo Empresa', icon: Icones.marca, action: () => navigateTo('/setup/grupo') }
]
export function setMainMenu(moduleId: string): NavigationMenuItem[] {
  switch (moduleId) {
    case ModuleType.CLINUX:
      return structuredClone(mainMenu)
    case ModuleType.PORTAL:
      return structuredClone(portalMenu)
    case ModuleType.OTRS:
      return structuredClone(otrsMenu)
    case ModuleType.DOCTOR:
      return structuredClone(doctorMenu)
    case ModuleType.CLIENT:
      return structuredClone(clientMenu)
    default:
      return []
  }
}
// const tools = {
//   label: 'Tools',
//   children: [
//     { label: 'Word', to: '/tools/editor', icon: Icones.editor },
//     { label: 'Excel', to: '/tools/excel', icon: Icones.excel },
//     { label: 'Pdf', to: '/tools/pdf', icon: Icones.pdf },
//     { label: 'Scanner', to: '/tools/scanner', icon: Icones.scanner },
//     { label: 'Schedule', to: '/tools/schedule', icon: Icones.calendario },
//     { label: 'Kanban', to: '/tools/kanban', icon: Icones.kanban },
//     { label: 'Form', to: '/tools/form', icon: Icones.formulario }
//   ]
// }
